import { Component } from '@angular/core';
import {lorem} from 'faker';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'TypingTest';
  result = false;
  enteredText = '';
  randomStr=lorem.sentences();

  getInputString(inputStr : string){
    this.enteredText = inputStr;
  }

  getCompare(randomLetter : string,eneteredLetter : string){
    if(!eneteredLetter){
      return 'pending';
    }
    if(randomLetter != eneteredLetter){
      return 'fail';
    }
    if(randomLetter == eneteredLetter){
      return 'success';
    }
  }
}
